import React from 'react';
import {
  Box,
  Typography,
  Alert
} from '@mui/material';

const VlansTab: React.FC = () => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        VLANs
      </Typography>
      <Alert severity="info">
        Funcionalidade de VLANs será implementada em breve.
      </Alert>
    </Box>
  );
};

export default VlansTab; 